<!--MOBILE-->
<!--<div class="tm-header-mobile uk-hidden@m">
<div *ngIf="beta" class="beta-badge-mobile"><span class="uk-label uk-label-danger">Beta instance<span class="uk-margin-small-left">&lt;</span></span></div>
<nav class="uk-navbar-container uk-navbar" uk-navbar="">
  <div class="uk-navbar-left">
    <a class="uk-navbar-toggle" href="#tm-mobile" uk-toggle="">
      <div uk-navbar-toggle-icon="" class="uk-navbar-toggle-icon uk-icon">
      </div>
    </a>
  </div>
  <div class="uk-navbar-center">
    <a class="uk-navbar-item uk-logo" [routerLink]="'/home'">
      <img src="../../../assets/images/logo-eosc-beyond-horizontal-fc.png"
        class="uk-responsive-height" alt="EOSC Portal">
    </a>
  </div>
</nav>
<div id="tm-mobile" uk-offcanvas="" mode="slide" overlay="" class="uk-offcanvas">
  <div class="uk-offcanvas-bar">
    <button class="uk-offcanvas-close uk-close uk-icon" type="button" uk-close="">
    </button>
    <div class="uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
      <div>
        <div class="uk-panel" id="module-0">
          <ul class="uk-nav uk-nav-default globalMenu">
            <li class="uk-nav-header" [routerLinkActive]="['uk-active']">
              <a href="https://eosc-portal.eu/contact-us" routerLinkActive="uk-active" class="uk-offcanvas-close offcanvas-close">Contact Us</a>
            </li>
            <li class="uk-nav-header" [routerLinkActive]="['uk-active']">
              <a href="https://eosc-portal.eu" routerLinkActive="uk-active" class="uk-offcanvas-close offcanvas-close">Portal Home</a>
            </li>
            <li class="uk-nav-header" [routerLinkActive]="['uk-active']">
              <a href="https://marketplace.eosc-portal.eu/" routerLinkActive="uk-active"
              class="uk-offcanvas-close offcanvas-close">Catalogue & Marketplace</a>
            </li>
            <li class="uk-nav-header" [routerLinkActive]="['uk-active']">
              <a href="https://providers.eosc-portal.eu/provider/my" routerLinkActive="uk-active"
              class="uk-offcanvas-close offcanvas-close">Providers Dashboard</a>
            </li>
            <li class="uk-nav-header" [routerLinkActive]="['uk-active']">
              <a href="https://eosc-portal.eu/providers-documentation" routerLinkActive="uk-active"
              class="uk-offcanvas-close offcanvas-close">Providers Documentation</a>
            </li>
            <li class="uk-nav-header" [routerLinkActive]="['uk-active']">
              <a *ngIf="authenticationService.isLoggedIn(); else loggedOut" routerLink="/home" (click)="this.authenticationService.logout()">
                <span> {{authenticationService.getUserName()}} {{authenticationService.getUserSurname()}} | Logout
                  <span class="uk-margin-small-right uk-icon"><svg width="20" height="20"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    ratio="1"><circle fill="none"
                    stroke="#000"
                    stroke-width="1.1"
                    cx="9.9" cy="6.4"
                  r="4.4"></circle><path
                  fill="none" stroke="#000" stroke-width="1.1"
                d="M1.5,19 C2.3,14.5 5.8,11.2 10,11.2 C14.2,11.2 17.7,14.6 18.5,19.2"></path></svg></span>
              </span>
            </a>
            <ng-template #loggedOut>
              <a class="loginLink" (click)="authenticationService.login()">Login</a>
            </ng-template>
          </li>


        </ul>
        <ul class="uk-nav uk-nav-default mainMenu">

          <li class="uk-parent" [routerLinkActive]="['uk-active']">
            <a [routerLink]="['/about']" routerLinkActive="uk-active">About</a>
          </li>

          <li class="uk-nav-header uk-parent" [routerLinkActive]="['uk-active']">For Providers
            <ul class="uk-nav-sub">
              <li><a [routerLink]="['/becomeAProvider']" routerLinkActive="uk-active"
              class="uk-offcanvas-close offcanvas-close">Become a Provider</a></li>
              <li *ngIf="authenticationService.isLoggedIn()"><a [routerLink]="['/provider/my']"
                routerLinkActive="uk-active"
              class="uk-offcanvas-close offcanvas-close">My Providers</a>
            </li>
            <li *ngIf="authenticationService.isAdmin()"><a [routerLink]="['/provider/all']" routerLinkActive="uk-active">View Providers</a></li>
            <li class="uk-nav-divider"></li>
            <li><a [routerLink]="['/developers']" routerLinkActive="uk-active">Public API</a></li>
          </ul>
        </li>

        <li class="uk-nav-header uk-parent" [routerLinkActive]="['uk-active']">For Catalogues
          <ul class="uk-nav-sub">
            <li>
              <a [routerLink]="['/catalogue/add']" routerLinkActive="uk-active" class="uk-offcanvas-close offcanvas-close">Add a Catalogue</a>
            </li>
            <li *ngIf="authenticationService.isLoggedIn()"><a [routerLink]="['/catalogue/my']"
            routerLinkActive="uk-active" class="uk-offcanvas-close offcanvas-close">My Catalogues</a>
          </li>
          <li *ngIf="authenticationService.isAdmin()">
            <a [routerLink]="['/catalogue/all']" routerLinkActive="uk-active">View Catalogues</a>
          </li>
          <li>
            <a [routerLink]="['/developers']" routerLinkActive="uk-active">Public API</a>
          </li>
        </ul>
      </li>

    </ul>
  </div>
</div>
</div>
</div>
</div>
</div>-->


<!--NO MOBILE-->
<div id="header_main" style="margin-top: 47px">
  @if (beta) {
    <div class="beta-badge uk-visible@m uk-padding"><span class="uk-label uk-label-danger">Beta instance</span></div>
  }
  <!--    <div id="top-header" class="uk-visible@m">-->
  <!--    <div class="uk-container">-->
  <!--      <div class="uk-grid">-->
  <!--        <div class="uk-width-1-1@m uk-text-right">-->
  <!--          <div class="region region-header-right">-->
  <!--            <div id="block-system-user-menu" class="block block-system block-border block-menu">-->
  <!--              <div class="content">-->
  <!--                <ul id="globalmenu" class="uk-nav uk-navbar-nav uk-navbar-right uk-float-right">-->
  <!--&lt;!&ndash;                  <li class="first leaf"><a href="https://eosc-portal.eu/contact-us">Contact Us</a></li>-->
  <!--                  <li class="leaf"><a href="https://eosc-portal.eu">Portal Home</a></li>-->
  <!--                  <li class="leaf"><a href="https://marketplace.eosc-portal.eu/">Catalogue & Marketplace</a></li>-->
  <!--                  <li class="leaf"><a class="active" href="https://providers.eosc-portal.eu/provider/my">Providers Dashboard</a></li>-->
  <!--                  <li class="leaf"><a href="https://eosc-portal.eu/providers-documentation">Providers Documentation</a></li>&ndash;&gt;-->
  <!--                  <li class="first leaf"><a href="./comingSoon">Contact Us</a></li>-->
  <!--                  <li class="leaf"><a href="./comingSoon">Portal Home</a></li>-->
  <!--                  <li class="leaf"><a href="./comingSoon">Catalogue & Marketplace</a></li>-->
  <!--                  <li class="leaf"><a class="active" href="./comingSoon">Providers Dashboard</a></li>-->
  <!--                  <li class="leaf"><a href="./comingSoon">Providers Documentation</a></li>-->
  <!--                  <ng-container *ngIf="!authenticationService.isLoggedIn()">-->
  <!--                    <li class="leaf"><a class="loginLink" (click)="authenticationService.login()">Login</a></li>-->
<!--                  </ng-container>-->
<!--                  <ng-container *ngIf="authenticationService.isLoggedIn()">-->
<!--                    <li class="leaf">-->
<!--                    <span class="username" title="{{authenticationService.getUserEmail()}}">-->
<!--                      <svg class="svg-inline&#45;&#45;fa fa-user fa-w-14 mr-1" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg>-->
<!--                      {{authenticationService.getUserName()}} {{authenticationService.getUserSurname()}}-->
<!--                    </span>-->
<!--                    </li>-->
<!--                    <li class="last leaf"><a (click)="this.authenticationService.logout()"><strong>Logout</strong></a></li>-->
<!--                  </ng-container>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->


<div class="main-menu tm-header uk-visible@m tm-header-transparent">
  <div class="uk-navbar-container uk-navbar-transparent" style="background-color: rgb(255, 255, 255);">
    <!--<div class="uk-navbar-container uk-sticky uk-navbar-transparent" uk-sticky="top:0" media="768"-->
    <!--cls-active="uk-active uk-navbar-sticky" style="" animation="uk-animation-slide-top"-->
    <!--top=".tm-header + [class*=&quot;uk-section&quot;]" cls-inactive="uk-navbar-transparent"-->
    <!--style="background-color: rgb(255, 255, 255);">-->
    <div class="uk-container" style="padding-top: 15px; padding-bottom: 15px;">
      <nav class="uk-navbar" uk-navbar="{&quot;align&quot;:&quot;left&quot;}">

        <div class="uk-navbar-left">
          <!--            <a class="uk-navbar-item uk-logo" [routerLink]="'/home'">-->
          <!--              <img src="../../../assets/images/logo-eosc-beyond-horizontal-fc.png"-->
          <!--                   class="uk-responsive-height" alt="EOSC Portal" style="width: 250px">-->
        <!--            </a>-->
      </div>
      <div class="uk-navbar-right align-self-center">
        <ul class="uk-navbar-nav">
          <li class="uk-parent" [routerLinkActive]="['uk-active']">
            <a [routerLink]="['/home']" routerLinkActive="uk-active">Home</a>
          </li>
          <li class="uk-parent" [routerLinkActive]="['uk-active']">
            <a [routerLink]="['/about']" routerLinkActive="uk-active">About</a>
          </li>

          <!--<li class="uk-parent" [routerLinkActive]="['uk-active']">
          <a href="#" class="" aria-expanded="false">
            Statistics
          </a>
          <div class="uk-navbar-dropdown uk-navbar-dropdown-bottom-left" style="top: 80px; left: 106.55px;"
            id="statistics" (click)="onClick('statistics')">
            <div class="uk-navbar-dropdown-grid uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
              <div class="uk-first-column">
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li><a [routerLink]="['/stats/providers']" routerLinkActive="uk-active">Providers</a></li>
                  <li><a [routerLink]="['/stats/resources']" routerLinkActive="uk-active">Resources</a></li>
                </ul>
              </div>
            </div>
          </div>
        </li>-->

        <li class="uk-parent" [routerLinkActive]="['uk-active']">
          <a href="#" class="" aria-expanded="false">
            For Providers
          </a>
          <div class="uk-navbar-dropdown uk-navbar-dropdown-bottom-left" style="top: 80px; left: 106.55px;"
            id="forProviders" (click)="onClick('forProviders')">
            <div class="uk-navbar-dropdown-grid uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
              <div class="uk-first-column">
                <ul class="uk-nav uk-navbar-dropdown-nav">
                  <li><a [routerLink]="['/becomeAProvider']" routerLinkActive="uk-active">Become a Provider</a></li>
                  @if (authenticationService.isLoggedIn()) {
                    <li><a [routerLink]="['/provider/my']" routerLinkActive="uk-active">My Providers</a></li>
                  }
                  <!--                        <li *ngIf="authenticationService.isLoggedIn()" class="uk-nav-divider"></li>-->
                  @if (authenticationService.isLoggedIn()) {
                    <li><a [routerLink]="['/developers']" routerLinkActive="uk-active">Public API</a></li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </li>

        <!--<li class="uk-parent" [routerLinkActive]="['uk-active']">
          <a href="#" class="" aria-expanded="false">
            For Catalogues
          </a>
          <div class="uk-navbar-dropdown uk-navbar-dropdown-bottom-left" style="top: 80px; left: 106.55px;"
            id="forCatalogues" (click)="onClick('forCatalogues')">
            <div class="uk-navbar-dropdown-grid uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
              <div class="uk-first-column">
                <ul class="uk-nav uk-navbar-dropdown-nav">
&lt;!&ndash;                  <li><a [routerLink]="['/catalogue/add']" routerLinkActive="uk-active">Add a Catalogue</a></li>&ndash;&gt;
                  @if (authenticationService.isLoggedIn()) {
                    <li><a [routerLink]="['/catalogue/my']" routerLinkActive="uk-active">My Catalogues</a></li>
                  }
                  @if (authenticationService.isLoggedIn()) {
                    <li><a [routerLink]="['/developers']" routerLinkActive="uk-active">Public API</a></li>
                  }
                </ul>
              </div>
            </div>
          </div>
        </li>-->

        @if (authenticationService.isAdmin()) {
          <li class="uk-parent" [routerLinkActive]="['uk-active']">
            <a href="#" class="" aria-expanded="false">
              For EPOT
            </a>
            <div class="uk-navbar-dropdown uk-navbar-dropdown-bottom-left" style="top: 80px; left: 106.55px; width: 220px"
              id="forEPOT" (click)="onClick('forProviders')">
              <div class="uk-navbar-dropdown-grid uk-child-width-1-1 uk-grid uk-grid-stack" uk-grid="">
                <div class="uk-first-column">
                  <ul class="uk-nav uk-navbar-dropdown-nav">
                    <li><a [routerLink]="['/provider/all']" routerLinkActive="uk-active">Providers</a></li>
                    <li><a [routerLink]="['/provider/resource/all']" routerLinkActive="uk-active">Services</a></li>
                    <li><a [routerLink]="['/catalogue/all']" routerLinkActive="uk-active">Catalogues</a></li>
                    <li><a [routerLink]="['/provider/datasource/all']" routerLinkActive="uk-active">Datasources</a></li>
                    <li><a [routerLink]="['/provider/training/all']" routerLinkActive="uk-active">Training Resources</a></li>
                    <li><a [routerLink]="['/provider/deployable-service/all']" routerLinkActive="uk-active">Deployable Application</a></li>
                    <li><a [routerLink]="['/provider/adapter/all']" routerLinkActive="uk-active">Adapters</a></li>
                    <li><a [routerLink]="['/guidelines/all']" routerLinkActive="uk-active">Guidelines</a></li>
<!--                    <li><a [routerLink]="['/vocabulary-requests']" routerLinkActive="uk-active">Vocabulary Requests</a></li>-->
                  </ul>
                </div>
              </div>
            </div>
          </li>
        }

      </ul>

    </div>
  </nav>
</div>
</div>
<div class="uk-sticky-placeholder" style="height: 100px; margin: 0px;" hidden="hidden"></div>
</div>
</div>

